const MXN_CURRENCY_FORMATTER = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DEFAULT_NUMBER_FORMATTER = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function toNumberOrNull(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function toNumber(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatNumber(
  value: unknown,
  emptyFallback?: string,
): string {
  if (value === null || value === undefined || value === '') {
    return emptyFallback ?? DEFAULT_NUMBER_FORMATTER.format(0);
  }

  return DEFAULT_NUMBER_FORMATTER.format(toNumber(value));
}

export function formatCurrency(
  value: unknown,
  emptyFallback?: string,
): string {
  if (value === null || value === undefined || value === '') {
    return emptyFallback ?? MXN_CURRENCY_FORMATTER.format(0);
  }

  return MXN_CURRENCY_FORMATTER.format(toNumber(value));
}

export function roundToDecimals(value: number, decimals: number): number {
  return Number(value.toFixed(decimals));
}

export function roundCurrency(value: number): number {
  return roundToDecimals(value, 2);
}

export function roundQuantity(value: number): number {
  return roundToDecimals(value, 3);
}
